export const CHART = {
  paper: "#f1ece0",
  foam: "#faf7ef",
  ink: "#22303c",
  muted: "#6d7278",
  line: "#c4cad0",
  sea: "#356274",
  sandLine: "#c9b98f",
  signal: "#df6631",
  signalDeep: "#b44e1f",
  gold: "#e3ad46",
} as const;

export const MONO_FONT = '"IBM Plex Mono", ui-monospace, monospace';

export const GAME_ASSET_URLS = {
  water: "/game-assets/ocean-chart.png",
  playerBoat: "/game-assets/sprites/player-boat.png",
  boatHarbourSloop: "/game-assets/boats/harbour-sloop.png",
  boatCoastalCutter: "/game-assets/boats/coastal-cutter.png",
  boatSteadyCatboat: "/game-assets/boats/steady-catboat.png",
  boatVoyagerKetch: "/game-assets/boats/voyager-ketch.png",
  boatMakerLaunch: "/game-assets/boats/maker-launch.png",
  boatCrewTug: "/game-assets/boats/crew-tug.png",
  boatSignalDhow: "/game-assets/boats/signal-dhow.png",
  island: "/game-assets/sprites/island.png",
  portMarker: "/game-assets/sprites/port-marker.png",
  messageBottle: "/game-assets/sprites/message-bottle.png",
  rescueRaft: "/game-assets/sprites/rescue-raft.png",
  lighthouse: "/game-assets/sprites/lighthouse.png",
  harbour: "/game-assets/sprites/harbour.png",
  dock: "/game-assets/sprites/dock.png",
  crewOtter: "/game-assets/sprites/crew-otter.png",
  fleetBoat: "/game-assets/sprites/fleet-boat.png",
  ruleBuoy: "/game-assets/sprites/rule-buoy.png",
  whale: "/game-assets/sprites/whale.png",
  landmarkTable: "/game-assets/sprites/landmark-table.png",
  landmarkWorkshop: "/game-assets/sprites/landmark-workshop.png",
  landmarkNoticewall: "/game-assets/sprites/landmark-noticewall.png",
} as const;

export type GameAsset = keyof typeof GAME_ASSET_URLS;

const images = new Map<GameAsset, HTMLImageElement>();

if (typeof Image !== "undefined") {
  for (const [key, url] of Object.entries(GAME_ASSET_URLS) as [GameAsset, string][]) {
    const image = new Image();
    image.decoding = "async";
    image.src = url;
    images.set(key, image);
  }
}

export function getGameAsset(key: GameAsset) {
  const image = images.get(key);
  return image?.complete && image.naturalWidth > 0 ? image : null;
}

export function drawGameAsset(
  ctx: CanvasRenderingContext2D,
  key: GameAsset,
  x: number,
  y: number,
  width: number,
  height: number,
  options: { rotation?: number; alpha?: number; anchorX?: number; anchorY?: number } = {},
) {
  const image = getGameAsset(key);
  if (!image) return false;

  const { rotation = 0, alpha = 1, anchorX = 0.5, anchorY = 0.5 } = options;
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(rotation);
  ctx.globalAlpha *= alpha;
  ctx.drawImage(image, -width * anchorX, -height * anchorY, width, height);
  ctx.restore();
  return true;
}

export function roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}
